<mariano-maxtopbar> </mariano-maxtopbar>
<div>
  <modal-open-point [mode]="'split'" id="articulo-pc-mmax-modal">
    <div split>
      <div class="articulomodalbackground">

      </div>
      <div class="cardcontainer">
        <div class="card">
          <div class="cardcontent">
            <div class="image-container-watermark">
              <img class="imagen myimg" [src]="imagesrc" loading="lazy">
              <div class="watermark-overlay" *ngIf="genServ.getMarcadeagua()"
                   [style.background-image]="'url(' + genServ.getLogoEmpresa() + ')'"
                   [style.opacity]="genServ.getOpacidadMarcadeagua()">
              </div>
            </div>
            <div class="descripcioncard">

              <div class="productoinfo">
                {{presentacion}}.
              </div>
              <div class="infomodal">
                Producto agregado al carrito
              </div>
            </div>

            <div class="unidades">
              {{cantidad}}un
            </div>
          </div>
        </div>

      </div>

    </div>

  </modal-open-point>

  <modal-open-point id="modal-error">
    <div normal>
      <modal-error></modal-error>
    </div>
  </modal-open-point>

  <modal-open-point id="modal-mensaje">
    <div normal>
      <modal-mensaje-mmax></modal-mensaje-mmax>
    </div>
  </modal-open-point>


  <div class="normalicedscreen" (click)="closeExtras()" (mousedown)="closeExtras()" (touchstart)="closeExtras()">

    <router-outlet></router-outlet>
  </div>

</div>